export { default as getDocumentAccessToken } from './getDocumentAccessToken';
export { default as saveDocumentAccessPassword } from './saveDocumentAccessPassword';
export { default as hasDocumentAccessPassword } from './hasDocumentAccessPassword';
